import { mobileMediaCSS } from '@1inch-community/core/lit-utils';
import { css } from 'lit';
export const notificationViewStyle = css `
  :host {
    position: relative;
    display: block;
  }

  .notification-container {
    --border-color: var(--primary-12);
    pointer-events: all;
    color: var(--color-content-content-primary);
    background-color: var(--color-background-bg-primary);
    border-radius: 8px;
    padding: 8px;
    box-sizing: border-box;
    width: 100%;
    min-height: 50px;
    border: 1px solid var(--border-color);
    transition: border 0.2s;
  }

  .notification-title {
    font-size: 16px;
    padding-bottom: 4px;
    display: flex;
  }

  .notification-time {
    font-size: 11px;
    color: var(--color-content-content-secondary);
    margin-left: auto;
  }

  .notification-time:dir(rtl) {
    margin-left: 0;
    margin-right: auto;
  }

  .error {
    --border-color: var(--color-background-bg-critical);
  }

  .warning {
    --border-color: var(--color-background-bg-warning);
  }

  .close-notification-button {
    pointer-events: all;
    position: absolute;
    top: -8px;
    right: -8px;
    transform: scale(0);
    transition: transform 0.2s;
  }

  @media (hover: hover) {
    .notification-container:hover {
      --border-color: var(--primary-50);
    }

    .notification-container.error:hover {
      --border-color: var(--color-background-bg-critical-hover);
    }

    .notification-container.warning:hover {
      --border-color: var(--color-background-bg-warning-hover);
    }

    .notification-container:hover .close-notification-button {
      transform: scale(1);
    }
  }

  ${mobileMediaCSS(css `
    :host {
      width: calc(100vw - 16px);
    }
  `)}
`;
//# sourceMappingURL=notification-view.style.js.map